// @flow

import * as React from "react";

import Section from "../Section/Section";
import FormRow from "../FormRow";
import SummaryCard from "./SummaryCard";

import summaryIcon from "../../assets/icons/details/summary.svg";
import purposeIcon from "../../assets/icons/details/purpose.svg";
import productIcon from "../../assets/icons/details/product.svg";
import { formatCurrency } from "../../utils/formatters";

type SummaryPanelProps = {
  amount: number,
  purposeKind: string,
  productKind: string
};

const SummaryPanel = ({ amount, purposeKind, productKind }: SummaryPanelProps) => (
  <Section title="Zusammenfassung" data-testid="summarypanel" reducedMargin numbered>
    <FormRow spacing="lg">
      <SummaryCard
        title="Finanzierungsbedarf"
        icon={{ src: summaryIcon, alt: "Finanzierungsbedarf" }}
      >
        {amount ? formatCurrency(amount) : "-"}
      </SummaryCard>
      <SummaryCard
        title="Investitionsvorhaben"
        icon={{ src: purposeIcon, alt: "Investitionsvorhaben" }}
      >
        {purposeKind}
      </SummaryCard>
      <SummaryCard
        title="Finanzierungsprodukt"
        icon={{ src: productIcon, alt: "Finanzierungsprodukt" }}
      >
        {productKind === "" ? "-" : productKind}
      </SummaryCard>
    </FormRow>
  </Section>
);

SummaryPanel.defaultProps = {
  amount: "",
  purposeKind: "",
  productKind: ""
};

export default SummaryPanel;
